import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { fetchBlueprintWithPreviewOperation } from 'js/src/data/blueprints/blueprints-operations';
import { selectSketchControlsBlueprintId } from 'js/src/data/sketch-controls/sketch-controls-selectors';
import { clearBlueprint } from 'js/src/data/sketch-controls/sketch-controls-slice';
import { useAppDispatch } from 'js/src/libs/RootState';
import { useLuminaryOperations } from 'js/src/luminary/luminary-hooks';

/**
 * Ensures the blueprint selected in the sketch controls is loaded in Redux,
 * with a preview thumbnail when it has no poster. The controls slice only
 * holds the id (e.g. restored from the sketch_controls cookie), while the
 * controls badge resolves its display name from the blueprints store —
 * without the entity, a persisted blueprint steers video creation with no
 * visible badge. If the blueprint can no longer be fetched (deleted or
 * inaccessible), the stale selection is cleared instead.
 */
export function useEnsureSelectedBlueprintLoaded(): void {
    const dispatch = useAppDispatch();
    const blueprintId = useSelector(selectSketchControlsBlueprintId);
    const { fetchBlueprintWithPreview } = useLuminaryOperations({
        fetchBlueprintWithPreviewOperation,
    });

    useEffect(() => {
        if (!blueprintId) {
            return;
        }

        fetchBlueprintWithPreview(blueprintId).then(({ blueprint }) => {
            if (!blueprint) {
                dispatch(clearBlueprint());
            }
        });
    }, [dispatch, blueprintId, fetchBlueprintWithPreview]);
}
